import { useMemo } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useFamily } from '../useFamily'

type SectionType =
  | 'renda'
  | 'educacao'
  | 'habitacao'
  | 'saude'
  | 'gravidez'
  | 'nutricao'

export default function useQuery() {
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const { families } = useFamily()

  const { type } = useParams()

  const basesQuery = JSON.parse(params.get('bases') ?? '').sort(
    (ant: { id: string; name: string }, pos: { id: string; name: string }) => {
      const antFamilyWithData: boolean =
        families.filter((family) => family?.base === ant.id)[0]?.family !==
        undefined
      const posFamilyWithData: boolean =
        families.filter((family) => family?.base === pos.id)[0]?.family !==
        undefined

      if (!antFamilyWithData && posFamilyWithData) return 1
      if (antFamilyWithData && !posFamilyWithData) return -1
      return 0
    }
  )

  const basesNames: Record<string, string> = {}

  basesQuery.forEach((base: { id: string; name: string }) => {
    basesNames[`${base.id}`] = base.name
  })

  const basesNameIdsPerName: Record<string, string> = {}

  basesQuery.forEach((base: { id: string; name: string }) => {
    basesNameIdsPerName[`${base.name}`] = base.id
  })

  return useMemo(() => {
    return {
      section: (type as SectionType) ?? '',
      cpf: params.get('cpf') ?? '',
      nis: params.get('nis') ?? '',

      familyCode: params.get('familyCode') ?? '',
      fieldName: params.get('fieldName') ?? '',
      familyMemberName: params.get('familyMemberName') ?? '',
      currenteBase: params.get('currenteBase') ?? '',
      infosRecommedation: params.get('infosRecommedation') ?? '',
      area: params.get('area') ?? '',
      basesIds: basesQuery.map((base: { id: string; name: string }) => {
        return base.id
      }),
      basesNamesList: basesQuery.map((base: { id: string; name: string }) => {
        return base.name
      }),
      basesNames,
      basesQuery,
      basesNameIdsPerName,
    }
  }, [search])
}
